import React from "react";
import { YhContainer } from "./YhContainer";

export interface YhAuthShellProps {
  children?: React.ReactNode;
  left?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
}

/**
 * Global auth layout — one container.
 * Prefer one child div with left + right columns.
 * Also supports left/right props.
 */
export const YhAuthShell = ({
  children,
  left,
  right,
  className = "",
}: YhAuthShellProps) => {
  const content =
    children ??
    (left != null || right != null ? (
      <div className="yh-auth-row">
        <div className="yh-auth-col yh-auth-col-left">{left}</div>
        <div className="yh-auth-col yh-auth-col-right">{right}</div>
      </div>
    ) : null);

  return (
    <YhContainer size="auth" className={className}>
      {content}
    </YhContainer>
  );
};

export default YhAuthShell;
